import { Grid } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MapTextField from 'components/Global/MapTextField';
import { isArray } from 'lodash';
import TipsIcon from 'components/TipsIcon';

const useStyles = makeStyles((theme) => ({
    container: {
        flex: 1,
        paddingTop: theme.spacing(1),
    },
    item: {
        paddingBottom: 12,
    },
}));
/**
 * @description: Input Form List mapping
 * @param {Object} props
 * @param {Object} props.formList
 * @param {Function} props.handleFormData textFiled onChange
 * @param {Element} props.children
 * @return {Element}
 */
function AddInputForm(props) {
    const {
        formList,
        handleFormData,
        children,
        alignItems = 'baseline',
        forceErrorDisplay,
        formValid,
        onRemove,
        ...rest
    } = props;
    const classes = useStyles();

    const onValidChange = (valid, name) => {
        formValid.current[name] = valid;
    };

    return (
        <Grid container alignItems="baseline" className={classes.container}>
            <Grid container justify="space-between">
                {formList &&
                    Object.keys(formList)
                        ?.filter((item) => item.type !== 'subTitle')
                        ?.map((i) => {
                            const item = formList[i];
                            const isEditRow = item.type === 'uploadFile' && !isArray(item.value);

                            if (typeof item.isDisabled === 'function') {
                                item.disabled = item.isDisabled(formList);
                            };
                            
                            return (
                                <Grid
                                    key={i}
                                    container
                                    item
                                    xs={item.itemXs ? item.itemXs : 12}
                                    wrap="nowrap"
                                    alignItems={item.alignItems ? item.alignItems : isEditRow ? 'center' : alignItems}
                                    className={classes.item}
                                >
                                    <Grid
                                        container
                                        item
                                        xs={item.labelItemXs ? item.labelItemXs : item.itemXs ? 4 : 2}
                                        wrap="nowrap"
                                        style={{lineHeight: 1.3}}
                                    >
                                        <div>
                                            {item.label}
                                            {item.labelTooltip && <TipsIcon title={item.labelTooltip} />}:
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: 10 }}></Grid>
                                    <Grid container item xs={item.itemXs ? 6 : 9} wrap="nowrap">
                                        <MapTextField
                                            isValidValue={(valid) => onValidChange(valid, item.name)}
                                            forceErrorDisplay={forceErrorDisplay}
                                            item={item}
                                            handleFormData={handleFormData}
                                            onRemove={onRemove}
                                            {...rest}
                                        />
                                    </Grid>
                                </Grid>
                            );
                        })}
            </Grid>
            {children}
        </Grid>
    );
}

export default AddInputForm;
